(ns app.front.view.common.header
  (:require [app.front.util :as futil]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.icons :as i]
            [re-frame.core-instrumented :as rf]))

(def full-header-info-storage-key "full-header-info")

(defn full-header-info-by-default? []
  (if-let [stored (futil/local-storage-get full-header-info-storage-key)]
    (= stored "true")
    true))

(defn set-full-header-info-default [full-info?]
  (futil/local-storage-set! full-header-info-storage-key (str full-info?)))

(rf/reg-sub ::map-visible?
  (fn [db [_ map-view-id]]
    (-> db ::map-view-id (= map-view-id))))

(rf/reg-event-db ::toggle-map-visibility
  (fn [db [_ map-view-id]]
    (-> db
        (update ::map-view-id (fn [old-id] (when (not= old-id map-view-id) map-view-id)))
        (assoc ::full-workspace-info-visible? false))))

(defn toggle-map-or-property-data-button [{:keys [tr map-view-id kind visible-class ws-view?]}]
  (let [units-ws?    (and (ff/enabled? :feature-flag.id/property-db-units)
                          ws-view?)
        close-tr     (if units-ws? :workspace/hide-property-modification :workspace/hide-map)
        open-tr      (if units-ws? :workspace/modify-property :workspace/show-map)
        map-visible? (<sub [::map-visible? map-view-id])
        label        (tr [(if map-visible? close-tr open-tr)])]
    (cc/button {:kind             (or kind :tertiary)
                :size             :small
                :icon             (if map-visible? i/remove i/map)
                :class-name       (if (and map-visible? visible-class)
                                    visible-class
                                    "")
                :icon-position    :right
                :icon-description label
                :on-click         #(>evt [::toggle-map-visibility map-view-id])}
               label)))
